<template>
    <div class="hidden-item-container">
        <p class="item-text">{{ item.displayName }}</p>
        <el-checkbox v-model="item.isShown" class="item-checkbox" @change="updateCheckbox" />
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
        }
    },
    data() {
        return {
            checked: true
        };
    },
    methods: {
        updateCheckbox(event) {
            console.log("update");
            this.$emit("updateHiddenItem", this.item.dataName);
        }
    },
};
</script>

<style lang="css" scoped>
.hidden-item-container {
    padding: var(--space-4) var(--space-8) var(--space-4) var(--space-12);
    border: 1px solid var(--seperation-line-grey);
    border-radius: var(--space-4);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-4);
    height: 35px;
}
.item-text {
    font-size: 14px;
    color: var(--charcoal-black);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 90%;
}
.item-checkbox {
    margin-right: var(--space-4);
}
</style>


// WEBPACK FOOTER //
// src/components/TableConfiguration/HiddenItem.vue